import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import { __decorate } from "tslib";
import { Component, createRef } from 'intact-vue-next';
import template from './index.vdt';
import { bind } from '../utils';
import { isArray } from 'intact-shared';
import { useConfigContext } from '../config';
var typeDefs = {
  disabled: Boolean,
  value: null,
  trueValue: null,
  falseValue: null,
  indeterminate: Boolean
};
var defaults = function defaults() {
  return {
    trueValue: true,
    falseValue: false
  };
};
var events = {
  click: true,
  change: true
};
export var Checkbox = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Checkbox, _Component);
  function Checkbox() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.inputRef = createRef();
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Checkbox.prototype;
  _proto.isChecked = function isChecked() {
    var _this$get = this.get(),
      value = _this$get.value,
      trueValue = _this$get.trueValue;
    return isArray(value) ? value.indexOf(trueValue) > -1 : value === trueValue;
  };
  _proto.setCheckboxModel = function setCheckboxModel(event) {
    var _event$target;
    var _this$get2 = this.get(),
      trueValue = _this$get2.trueValue,
      falseValue = _this$get2.falseValue;
    var checked = (_event$target = event.target) == null ? void 0 : _event$target.checked;
    var value = this.get('value');
    if (isArray(value)) {
      value = _sliceInstanceProperty(value).call(value, 0);
      var index = value.indexOf(trueValue);
      if (checked) {
        if (index === -1) {
          value.push(trueValue);
        }
      } else {
        if (index > -1) {
          _spliceInstanceProperty(value).call(value, index, 1);
        }
      }
    } else {
      value = checked ? trueValue : falseValue;
    }
    this.set('value', value);
  };
  _proto.onClick = function onClick(e) {
    // ignore the click event from label, otherwise it will trigger click event twice
    if (e.target !== this.inputRef.value) {
      e.stopPropagation();
      return;
    }
    var _this$get3 = this.get(),
      disabled = _this$get3.disabled;
    if (disabled) {
      this.trigger('click', e);
    } else {
      this.setCheckboxModel(e);
      this.trigger('click', e);
      this.trigger('change', this.get('value'), e);
    }
  };
  _proto.onKeypress = function onKeypress(e) {
    if (e.keyCode === 13 || e.key === 'Enter') {
      this.inputRef.value.click();
    }
  };
  return Checkbox;
}(Component);
Checkbox.template = template;
Checkbox.typeDefs = typeDefs;
Checkbox.defaults = defaults;
Checkbox.events = events;
__decorate([bind], Checkbox.prototype, "onClick", null);
__decorate([bind], Checkbox.prototype, "onKeypress", null);